<template>
  <div id="app">
    <h2 class="center-align">Community Metric Explorer</h2>
        <p class="center-align">This tool allows users to see whether data is available for evaluating the financial, human, and technical capacity of specific Alaska communities to undertake energy projects.</p>
    <div class="divider"></div>
    <div class="row">
      <div class="col s10">
        <div class="row">
          <div class="col s12">
            <h4 class="center-align">Step 1: Select a Metric Category</h4>
          </div>
        </div>
        <metric-selector></metric-selector>
        <div class="row">
          <div class="col s12">
            <h4 class="center-align">Step 2: Select Communities</h4>
          </div>
        </div>
        <div class="row community-selection-container">
          <div class="col l7 s6">
            <community-map></community-map>
          </div>
          <div class="col l5 s6">
            <community-select-box></community-select-box>
          </div>
        </div>
        <div class="row">
          <div class="col s12">
            <h4 class="center-align">Step 3: View Metrics for Communities</h4>
          </div>
        </div>
        <results-list></results-list>

      </div>
      <div class="col s2">
        <sticky-legend></sticky-legend>
      </div>
    </div>

  </div>
</template>

<script>
import MetricSelector from './components/MetricSelector.vue'
import CommunityMap from './components/CommunityMap.vue'
import ResultsList from './components/ResultsList.vue'
import CommunitySelectBox from './components/CommunitySelectBox.vue'
import StickyLegend from './components/StickyLegend.vue'
export default {
  name: 'app',
  components: {
    CommunitySelectBox,
    CommunityMap,
    MetricSelector,
    ResultsList,
    StickyLegend
  }
}
</script>

<style>
#app {
  /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  /*margin-top: 60px;*/
}

  .community-selection-container {
    height: 600px;
  }

  .community-selection-container .col {
    height: inherit;
  }
</style>



// WEBPACK FOOTER //
// App.vue?591b53b0